module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic3.be84e0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic3.png
// module id = 482
// module chunks = 1